"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBalanceOperation = void 0;
var dataTypes_1 = require("../../dataTypes");
var SolNetworkResolver_1 = require("../../SolNetworkResolver");
/** Gets native balance owned by the given network and address */
exports.getBalanceOperation = {
    method: 'GET',
    name: 'getBalance',
    id: 'balance',
    groupName: 'account',
    urlPathParamNames: ['network', 'address'],
    urlPathPattern: '/account/{network}/{address}/balance',
    getRequestUrlParams: getRequestUrlParams,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request, core) {
    return {
        network: SolNetworkResolver_1.SolNetworkResolver.resolve(request.network, core),
        address: dataTypes_1.SolAddress.create(request.address).address,
    };
}
function deserializeResponse(jsonResponse) {
    return dataTypes_1.SolNative.create(jsonResponse.lamports);
}
function serializeRequest(request, core) {
    return {
        address: dataTypes_1.SolAddress.create(request.address).address,
        network: SolNetworkResolver_1.SolNetworkResolver.resolve(request.network, core),
    };
}
function deserializeRequest(jsonRequest) {
    return {
        network: dataTypes_1.SolNetwork.create(jsonRequest.network),
        address: dataTypes_1.SolAddress.create(jsonRequest.address),
    };
}
//# sourceMappingURL=getBalanceOperation.js.map